import React from 'react';

class Footer extends React.Component{
    render(){
        return(
            <div className='footer'>
                Footer
            </div>
        );//return end
    }//render end
}//class Footer end

export default Footer;
